import React, { useEffect, useState } from 'react';
import './EmployerList.css';
import http from '../../services/http-service'
// import { DataGrid } from '@mui/x-data-grid';
import { ToastContainer, toast } from 'react-toastify';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import { styled, alpha } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import Stack from '@mui/material/Stack';
import { NavLink, useHistory } from "react-router-dom";
import Pagination from '@mui/material/Pagination';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { confirm } from 'react-confirm-box';
import EditIcon from '@mui/icons-material/Edit';
import SettingsIcon from '@mui/icons-material/Settings';
import DeleteIcon from '@mui/icons-material/Delete';
import debounce from 'lodash.debounce';

const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
        '& .MuiSwitch-thumb': {
            width: 15,
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
            transform: 'translateX(9px)',
        },
    },
    '& .MuiSwitch-switchBase': {
        padding: 2,
        '&.Mui-checked': {
            transform: 'translateX(12px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#1890ff',
            },
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
        width: 12,
        height: 12,
        borderRadius: 6,
        transition: theme.transitions.create(['width'], {
            duration: 200,
        }),
    },
    '& .MuiSwitch-track': {
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor:
            theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
        boxSizing: 'border-box',
    },
}));

const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
    },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
                width: '20ch',
            },
        },
    },
}));

function AdminEmployers(props) {
    const history = useHistory();
    const [count, setCount] = useState(0);
    const [open, setOpen] = useState(false);
    const [searchItem, setSearchItem] = useState('');
    const [tableData, setTableData] = useState([]);
    const [currentPage, setCurrentPage] = useState(parseInt(props.match.params.page))

    const fetchEmployerData = (value, search) => {
        if (value)
            setCurrentPage(value)
        else
            setCurrentPage(1)

        let params = {
            page: value,
            search: search
        }
        handleToggle()
        http('admin/employer/', 'GET', '', params)
            .then(res => {
                if (res.status) {
                    setCount(0)
                    setCount(Math.ceil(res.data.count / res.data.page_size))
                    setTableData(res.data.results)
                }
                else {
                    toast.error(res.message,{
                        toastId: "toastId1"
                      })
                }
                handleClose()
            },
                err => {
                    handleClose()
                    console.log('err....', err)
                })
    }

    const handleSearch = debounce((value) => {
        setSearchItem(value)
        setCurrentPage(1)
        history.push('/employer-list/' + 1)
        fetchEmployerData(1, value)
    }, 1000)

    useEffect(() => {
        fetchEmployerData(currentPage, searchItem);
        // eslint-disable-next-line
    }, []);

    const handleEmployerStatus = (cellData) => {
        console.log(cellData)
        let postData = {
            employer_id: cellData.company.user,
            status: !cellData.is_active
        }

        handleToggle()
        http('admin/update_employer_status/', 'PATCH', postData)
            .then(res => {
                if (res.data.status) {
                    toast.success(res.data.message,{
                        toastId: "toastId2"
                      })
                    fetchEmployerData(currentPage, searchItem)
                }
                else {
                    toast.error(res.data.message,{
                        toastId: "toastId3"
                      })
                    handleClose()
                }

            },
                err => {
                    handleClose()
                    console.log('err....', err)
                })
    }

    const handleClose = () => {
        setOpen(false);
    };
    const handleToggle = () => {
        setOpen(!open);
    };

    const handleChangePage = (event, page) => {
        history.push('/employer-list/' + page)
        fetchEmployerData(page, searchItem)
    }

    const addEmployers = () => {
        history.push("/add-employer");
    }

    const confirmUser = async (data) => {
        const status = data.is_active ? 'Inactive' : 'Active'
        const message = 'Are you sure, you want to ' + status + ' this user?';
        const options = {
            title: "Confirm",
            labels: {
                confirmable: "Confirm",
                cancellable: "Cancel"
            },
            closeOnOverlayClick: true
        }
        const result = await confirm(message, options);
        if (result) {
            handleEmployerStatus(data)
        }
        console.log("You click No!");
    };

    const confirmDeleteUser = async (data) => {
        const message = 'Are you sure, you want to remove this user?';
        const options = {
            title: "Confirm",
            labels: {
                confirmable: "Confirm",
                cancellable: "Cancel"
            },
            closeOnOverlayClick: true
        }
        const result = await confirm(message, options);
        if (result) {
            removeEmployer(data.id)
        }
        console.log("You click No!");
    };

    const removeEmployer = (id) => {
        handleToggle()
        http('admin/delete_employer/' + id + '/', 'DELETE')
            .then(res => {
                if (res.data.status) {
                    toast.success(res.data.message,{
                        toastId: "toastId4"
                      })
                    fetchEmployerData(currentPage, searchItem)
                }
                else {
                    toast.error(res.data.message,{
                        toastId: "toastId5"
                      })
                    handleClose()
                }

            },
                err => {
                    handleClose()
                    console.log('err....', err)
                })
    }

    const gotoSettings = (id) => {
        history.push({
            pathname: '/configuration',
            search: '?id=' + id
        })
    }

    return (
        <div className="mainAppDiv">
            <ToastContainer />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <div className='employeeHeading_row'>
                <div className='employeeHeading'> Employer Management </div>
                <Grid item lg={4} className='upsearchGrid'>
                    <Search className='upseacrchDiv'>
                        <SearchIconWrapper>
                            <SearchIcon />
                        </SearchIconWrapper>
                        <StyledInputBase onChange={(e) => {

                            handleSearch(e.target.value)
                        }}
                            placeholder="Search…"
                            inputProps={{ 'aria-label': 'search' }}
                        />
                    </Search>
                </Grid>
                <Stack direction="row" spacing={2} className="justifyEnd">
                    <Button variant="contained" onClick={addEmployers}>Add Employer</Button>
                </Stack>
            </div>
            {
                tableData.length > 0 ? (
                    <div>
                        <div className='customTable'>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Employer ID</th>
                                        <th>Employer Name</th>
                                        <th>Legal Name</th>
                                        <th>Cac Registration Number</th>
                                        <th>Tax Identification Number</th>
                                        <th>Total Net Monthly Payroll</th>
                                        <th>Total Number Of Employees</th>
                                        <th>Contact Name</th>
                                        <th>Email</th>
                                        <th>Phone Number</th>
                                        <th>Address Line 1</th>
                                        <th>Address Line 2</th>
                                        <th>City</th>
                                        <th>Region Code</th>
                                        <th>Country Code</th>
                                        <th>Postal Code</th>
                                        <th>Website</th>
                                        <th>Active</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {tableData.map((data, index) => (
                                        <tr key={index}>
                                            <td key={'employer_id' + index} >{data.company.employer_id}</td>
                                            <td key={'name' + index}>{data.company.name}</td>
                                            <td key={'legal_name' + index}>{data.company.legal_name}</td>
                                            <td key={'cac_registration_number' + index}>{data.company.cac_registration_number}</td>
                                            <td key={'tax_identification_number' + index}>{data.company.tax_identification_number}</td>
                                            <td key={'total_net_monthly_payroll' + index}>{data.company.total_net_monthly_payroll}</td>
                                            <td key={'total_number_of_employees' + index}>{data.company.total_number_of_employees}</td>
                                            <td key={'contact_name' + index}>{data.first_name}</td>
                                            <td key={'email' + index}>{data.email}</td>
                                            <td key={'phone_number' + index}>{data.phone_number}</td>
                                            <td key={'address' + index}>{data.company.address}</td>
                                            <td key={'address_line_2' + index}>{data.company.address_line_2}</td>
                                            <td key={'city' + index}>{data.company.city}</td>
                                            <td key={'region_code' + index}>{data.company.region_code}</td>
                                            <td key={'country_code' + index}>{data.company.country_code}</td>
                                            <td key={'postal_code' + index}>{data.company.postal_code}</td>
                                            <td key={'website' + index}>{data.company.website}</td>
                                            <td key={'is_active' + index}>
                                                <FormGroup>
                                                    <Stack direction="row" spacing={1} alignItems="center">
                                                        <AntSwitch
                                                            checked={data.is_active}
                                                            onChange={() => confirmUser(data)}
                                                            inputProps={{ 'aria-label': 'ant design' }} />
                                                    </Stack>
                                                </FormGroup>
                                            </td>
                                            <td key={'action_' + index}>
                                                <NavLink to={"/edit-employer/" + data.id} className='colorBlue'><EditIcon></EditIcon></NavLink>

                                                {
                                                    data.is_active ? (
                                                        <SettingsIcon style={{ cursor: 'pointer' }} onClick={() => {
                                                            gotoSettings(data.company.employer_id)
                                                        }} />
                                                    ) : (
                                                        <SettingsIcon style={{color: '#bfbfbf'}} />
                                                    )
                                                }
                                                <DeleteIcon style={{ cursor: 'pointer', color: 'red' }} onClick={() => { confirmDeleteUser(data) }} />

                                            </td>
                                        </tr>
                                    ))}


                                </tbody>
                            </table>

                        </div>
                        <Stack spacing={2} className="employeePagination">
                            <Pagination count={count} color="primary" page={currentPage} onChange={handleChangePage} />
                        </Stack>
                    </div>

                ) : (
                    <div className='recordNotFoundDiv'>
                        <h2>Records Not Found</h2>
                    </div>
                )
            }

        </div>
    )
}

export default AdminEmployers;
